import { columnVisibilityFeature, rowSortingFeature, tableFeatures } from '@tanstack/react-table';

/**
 * The register's table engine: TanStack Table v9's native API, with every feature named.
 *
 * **Nothing is included by default in v9, and nothing is included by accident here.** The two
 * features below are the two this screen still uses — hiding a column, and the header state that
 * says which column a list is ordered by — and each one is a module that would otherwise not be in
 * the bundle. `useLegacyTable` and `stockFeatures` both exist and both pull in everything; neither
 * is used, because the bundle this application ships is measured against a budget that can only
 * ever be tightened.
 *
 * **Filtering, ordering and paging left this file when they became the SERVER's.** They are not
 * disabled here, they are somewhere else: `GET /api/v1/persons` applies every narrowing over
 * everybody before it counts, orders by the column the header asked for and answers one numbered
 * page. A row model that filtered, sorted or paged on top of that would be a second opinion about
 * twenty rows, printed beside a page count describing the whole register — which is the confusion
 * this screen exists to avoid. `manualSorting` on the table is what tells v9 to hand back the rows
 * it was given, in the order they arrived.
 *
 * **What is left is a renderer with a sort indicator.** `rowSortingFeature` supplies
 * `getCanSort`, `getIsSorted` and `getToggleSortingHandler`, which is what keeps the header a real
 * button with a real `aria-sort`; it needs no sort function, because no row model ever calls one.
 */

/** The features this table has, and therefore the only ones its bundle carries. */
export const registerTableFeatures = tableFeatures({
  columnVisibilityFeature,
  rowSortingFeature,
});

export type RegisterTableFeatures = typeof registerTableFeatures;

/**
 * How many rows a page of the register holds.
 *
 * It is sent to the server as `limit` rather than applied to what came back, so this number and the
 * `pageCount` the screen prints beside it are the same number seen from two ends.
 */
export const ROWS_PER_PAGE = 20;
